module.exports = __webpack_public_path__ + "static/img/title.843d19d.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/title.png
// module id = P034
// module chunks = 0